import { useInfiniteQuery } from "@tanstack/react-query";

import { useAuth } from "@/providers";
import { useDomainServices } from "@/providers/DomainServices";

import * as Comments from "./getQueryKey";

interface UseCommentsForUserParams {
  userId: string;
}

export function getQueryKey(orgId: string, params: UseCommentsForUserParams) {
  const { userId } = params;
  return [...Comments.getQueryKey(orgId), "user", userId];
}

export function useCommentsForUser(params: UseCommentsForUserParams) {
  const { commentService } = useDomainServices();
  const { currentOrganization } = useAuth();

  const orgId: string = currentOrganization?.org_id ?? "";
  const { userId } = params;

  return useInfiniteQuery({
    queryKey: getQueryKey(orgId, params),
    queryFn: async ({ pageParam, signal }) => {
      if (!orgId) {
        throw new Error("No organization selected");
      }

      return commentService.getCommentsForUser(userId, {
        orgId,
        pageToken: pageParam,
        abortSignal: signal,
      });
    },
    select: (data) => data.pages.flatMap((page) => page.items),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_token,
    enabled: currentOrganization !== null,
    staleTime: 60000, // 1 minute
  });
}
